export default __webpack_public_path__ + "static/media/bg-card-02.bdba575a.jpg";